import { BaseApi } from '../base-api';

export class EmailSubscriptionApi extends BaseApi {
  protected readonly prefix = 'agents/subscription';

  unsubscribe = (type: string, hash: string) => this.delete(`${type}/?hash=${hash}`);
}
